export default () => ({
  currentBasket: null,
  loadingAdditionalData: null,
  loading: null,
  busyOfferLines: {},
  basketReloadPending: false,
  basketReloadQueued: false,
})
